<template>
  <div class="c-map-modal" v-if="showModal">
    <div class="c-map-modal__shadow" v-on:click="closeButtonClickHandler"></div>
    <dialog
      class="c-map-modal__body"
      v-if="!loading"
      v-bind:aria-labelledby="'modalTitle' + _uid"
      aria-modal="true"
    >
      <slot name="content"></slot>

      <div v-if="location" class="c-map-modal__inner">
        <div v-if="location.adHocPolygonType">
          <div class="c-map-modal__header c-map-modal__header--border">
            <img class="c-map-modal__header-icon" :src="location.icon" alt="" />
            <div class="c-map-modal__header-content">
              <h3 :id="'modalTitle' + _uid" class="c-map-modal__title">
                {{ location.layerName }}
              </h3>
            </div>
          </div>
          <div class="c-map-modal__content">
            <h4 class="c-map-modal__content-title">
              {{ location.group1Title }}
            </h4>
            <div class="grid-x grid-margin-x o-columns__one">
              <div class="cell c-map-modal__cell">
                <div
                  v-html="location.defaultText"
                  class="c-map-modal__description"
                ></div>
              </div>
            </div>

            <div class="grid-x grid-margin-x o-columns__two">
              <div class="cell c-map-modal__cell">
                <h4 class="c-map-modal__label">
                  {{ location.startTitle }}
                </h4>
                <p class="c-map-modal__description">
                  {{ this.formatDate(location.startDate) }}
                </p>
              </div>
              <div class="cell c-map-modal__cell">
                <h4 class="c-map-modal__label">
                  {{ location.endTitle }}
                </h4>
                <p class="c-map-modal__description">
                  {{ this.formatDate(location.endDate) }}
                </p>
              </div>
            </div>
            <div
              v-if="location.attachments"
              class="grid-x grid-margin-x o-columns__one"
            >
              <div class="cell c-map-modal__cell">
                <h4 class="c-map-modal__label">
                  {{ location.attachmentTitle }}
                </h4>
                <p class="c-map-modal__description">
                  <a
                    v-for="attachment in location.attachments"
                    v-bind:key="attachment.index"
                    :href="attachment.url"
                    target="_blank"
                    class="c-map-modal__link"
                    >
                    <svg
                      class="c-map-modal__link-icon"
                      focusable="false"
                      aria-hidden="true"
                    >
                      <use xlink:href="#pdf" />
                    </svg>
                    {{ attachment.attachmentName }}</a
                  >
                </p>
              </div>
            </div>
            <h3 class="c-map-modal__content-title">
              {{ location.group2Title }}
            </h3>
            <div class="grid-x grid-margin-x o-columns__one">
              <div class="cell c-map-modal__cell">
                <div
                  v-html="location.contactText"
                  class="c-map-modal__description"
                ></div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="location.trafficManagement">
          <div class="c-map-modal__header c-map-modal__header--border">
            <img class="c-map-modal__header-icon" :src="icon.url" alt="" />
            <div class="c-map-modal__header-content">
              <h3 class="c-map-modal__title">
                {{ this.getPriorityTitle(location.worksCategory) }}
              </h3>
              <p class="c-map-modal__strapline">
                {{ location.address1 }}, {{ location.town }}
              </p>
            </div>
          </div>
          <div class="c-map-modal__content">
            <h3 class="c-map-modal__content-title">{{ layer.group1Title }}</h3>
            <div class="grid-x grid-margin-x o-columns__two">
              <div class="cell c-map-modal__cell">
                <h4 class="c-map-modal__label">
                  {{ layer.trafficControlTitle }}
                </h4>
                <p class="c-map-modal__description">
                  {{ location.trafficManagementDescription }}
                </p>
              </div>
            </div>
            <div class="grid-x grid-margin-x o-columns__two">
              <div class="cell c-map-modal__cell">
                <h4 class="c-map-modal__label">{{ layer.startTitle }}</h4>
                <p class="c-map-modal__description">
                  {{ this.formatDate(location.startDate) }}
                </p>
              </div>
              <div class="cell c-map-modal__cell">
                <h4 class="c-map-modal__label">{{ layer.endTitle }}</h4>
                <p class="c-map-modal__description">
                  {{ this.formatDate(location.endDate) }}
                </p>
              </div>
            </div>
            <div class="grid-x grid-margin-x o-columns__one">
              <div
                v-if="location.emergencyWorks"
                class="cell c-map-modal__cell"
              >
                <div
                  v-html="layer.emergencyWorksText"
                  class="c-map-modal__description"
                ></div>
              </div>
            </div>
            <h3 class="c-map-modal__content-title">{{ layer.group2Title }}</h3>
            <div class="grid-x grid-margin-x o-columns__one">
              <div class="cell c-map-modal__cell">
                <div
                  v-html="layer.contactText"
                  class="c-map-modal__description"
                ></div>
              </div>
            </div>
            <div class="grid-x grid-margin-x o-columns__one">
              <div class="cell c-map-modal__cell">
                <h4 class="c-map-modal__label">{{ layer.referenceTitle }}</h4>
                <p class="c-map-modal__description">
                  {{ location.worksReference }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div v-if="location.incidentType">
          <div class="c-map-modal__header c-map-modal__header--border">
            <img class="c-map-modal__header-icon" :src="icon.url" alt="" />
            <div class="c-map-modal__header-content">
              <h3 class="c-map-modal__title">
                {{ layer.layerName }}
              </h3>
            </div>
          </div>
          <div class="c-map-modal__content">
            <h4 class="c-map-modal__content-title">{{ layer.group1Title }}</h4>
            <div class="grid-x grid-margin-x o-columns__one">
              <div class="cell c-map-modal__cell">
                <div
                  v-html="layer.defaultText"
                  class="c-map-modal__description"
                ></div>
              </div>
            </div>
            <h3 class="c-map-modal__content-title">{{ layer.group2Title }}</h3>
            <div class="grid-x grid-margin-x o-columns__one">
              <div class="cell c-map-modal__cell">
                <div
                  v-html="layer.contactText"
                  class="c-map-modal__description"
                ></div>
              </div>
            </div>
            <div class="grid-x grid-margin-x o-columns__one">
              <div class="cell c-map-modal__cell">
                <h4 class="c-map-modal__label">{{ layer.referenceTitle }}</h4>
                <p class="c-map-modal__description">
                  {{ location.rapidReference }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div v-if="coastwatch">
          <div class="c-map-modal__header">
            <div v-if="desktop" class="c-map-modal__header-image-container">
              <img
                class="c-map-modal__header-image"
                :src="location.imgSrc"
                :alt="location.imgAlt"
              />
            </div>
            <img
              v-if="!desktop"
              class="c-map-modal__header-icon"
              :src="icon.url"
              alt=""
            />
            <div class="c-map-modal__header-content">
              <h3 class="c-map-modal__title">
                {{ location.name }}
              </h3>
              <p class="c-map-modal__subtitle">
                {{ location.quality }}
              </p>
              <p v-if="desktop" class="c-map-modal__strapline">
                {{ location.desc }}
              </p>
              <a v-if="desktop" class="c-button" target="_blank" :href="layer.environmentLink">{{
                layer.environmentLinkTitle
              }}</a>
            </div>
          </div>
          <div v-if="!desktop">
            <p class="c-map-modal__description">
              {{ location.desc }}
            </p>
            <a class="c-button" target="_blank" :href="layer.environmentLink">{{
              layer.environmentLinkTitle
            }}</a>
          </div>

          <MapTabs v-on:activeTab="selectedTab">
            <MapTab
              name="mapSummary"
              panelSuffix="Panel"
              tabSuffix="Tab"
              v-bind:isActive="true"
              v-bind:title="layer.summaryTitle"
              v-on:tabClick="onTabClick"
            >
              <p class="c-map-modal__description">
                <strong>{{ coastwatch.summary.heading }}</strong>
              </p>
              <h4 class="c-map-modal__heading" v-if="spillHistory">
                {{ coastwatch.summary.spillHistoryLabel }}
              </h4>
              <div class="c-map-spill" v-if="spillHistory">
                <div class="c-map-spill__list">
                  <div
                    v-for="item in spillHistoryDetails"
                    v-bind:key="item.index"
                    class="c-map-spill__item"
                  >
                    <span class="c-map-spill__item-date">{{ item.date }}</span>

                    <span class="c-map-spill__item-result">{{ item.result }}</span>
                  </div>
                </div>

                <p v-if="coastwatch" class="c-map-modal__description">
                  {{ coastwatch.summary.spillDisclaimerText }}
                </p>
              </div>
            </MapTab>
            <MapTab
              name="mapInformation"
              panelSuffix="Panel"
              tabSuffix="Tab"
              v-bind:isActive="false"
              v-bind:title="layer.informationTitle"
              v-on:click="onTabClick"
            >
                <p class="c-map-modal__description">
                  <strong>
                    {{ coastwatch.information.beachStatusText }}
                  </strong>
                </p>
                <div class="c-map-modal__description" v-html="coastwatch.information.informationText"></div>
            </MapTab>
            <MapTab
              name="mapWeather"
              panelSuffix="Panel"
              tabSuffix="Tab"
              v-bind:isActive="false"
              v-bind:title="layer.weatherTitle"
              v-on:click="onTabClick"
            >
              <div class="c-map-weather" v-if="weather">
                <div class="c-map-weather__list">
                  <div
                    v-for="item in weatherDetails"
                    v-bind:key="item.index"
                    class="c-map-weather__item"
                  >
                    <p class="c-map-weather__item-date">{{ item.day }}</p>
                    <svg
                      class="c-map-weather__item-icon"
                      aria-hidden="true"
                      focusable="false"
                    >
                      <use
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        :xlink:href="item.icon"
                      ></use>
                    </svg>
                    <p class="c-map-weather__item-temp">{{ item.temp }}</p>
                  </div>
                </div>
              </div>
            </MapTab>
          </MapTabs>
        </div>
      </div>
      <div class="c-map-modal__action">
        <button
          class="c-button c-button--cover"
          type="button"
          ref="close"
          tabindex="0"
          v-on:click="closeButtonClickHandler"
          v-on:keydown.tab="onFocusoutClose"
        >
          <svg class="c-button__icon" aria-hidden="true" focusable="false">
            <use
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xlink:href="#map-close"
            ></use>
          </svg>
          <span class="visually-hidden">Close modal</span>
        </button>
      </div>
    </dialog>
    <LoadingSpinner v-if="loading"></LoadingSpinner>    
  </div>
</template>

<script>
import moment from "NodeModules/moment/moment";
import axios from "axios";
import endpoints from "Globals/mando.endpoints";
import MapTabs from "./MapTabs";
import MapTab from "./MapTab";
import LoadingSpinner from "Components/consumer/_vue-shared/LoadingSpinner.vue";


export default {
  name: "MapModal",
  components: {
    MapTabs,
    MapTab,
    LoadingSpinner
  },
  props: ["desktop", "id", "map", "modalContent", "showModal"],
  data() {
    return {
      activeTab: null,
      coastwatch: null,
      icon: null,
      lat: null,
      layer: null,
      location: null,
      loading: false,
      long: null,
      spillHistory: null,
      spillHistoryDetails: [
        {
          date: null,
          hasSpill: null,
          result: null,
        },
      ],
      weather: false,
      weatherDetails: [
        {
          day: null,
          icon: null,
          temp: null,
        },
      ],
      weatherError: false,
    };
  },
  watch: {
    id() {
      this.updateContent();
      this.getLocationDetails();
      this.updatePosition();
      this.weather = false;
    },
  },
  methods: {
    updatePosition() {
      this.lat = this.location.latitude;
      this.long = this.location.longitude;
    },
    getWeatherDataSuccess(response) {
      const { data } = response;
      this.weather = true;
      this.weatherDetails = data.list.map((day, i) => {
        return {
          day: moment().add(i, "days").format("ddd"),
          icon: `#${day.weather[0].icon}`,
          temp: `${Math.round(parseFloat(day.temp.max, 10))}°C`,
        };
      });
    },
    getWeatherData() {
      if (this.weather) return;
      axios
        .get(
          `${endpoints("getWeatherDetails")}?lat=${this.lat}&lon=${
            this.long
          }&mode=json&units=metric&cnt=7&APPID=7c686ce21e2334b80b048cbc25a0ec2c`
        )
        .then(this.getWeatherDataSuccess)
        .catch((this.weatherError = true));
    },
    selectedTab(id) {
      this.activeTab = id;
      if (this.activeTab === "mapWeatherTab") {
        this.getWeatherData();
      }
    },
    updateContent() {
      this.location = this.modalContent.location;
      this.layer = this.modalContent.layerDetails;
      this.icon = this.modalContent.icon;
    },
    getLocationDetails() {
      this.locationDetailsError = false;

      if (
        this.modalContent.layer &&
        this.location &&
        this.modalContent.layer.includes("COASTWATCH")
      ) {
         this.loading = true;
        axios
          .get(
            `${endpoints("getCoastwatchLocationDetails")}?id=${this.location.id}`
          )
          .then(this.getLocationDetailsSuccess)
          .catch((error) => console.error(error))
          .finally(this.getLocationDetailsFinally)
      } else {
        this.coastwatch = false;
      }
    },
    getLocationDetailsSuccess(response) {
      this.coastwatch = response.data.location;
      if (!this.coastwatch.summary.spillData) return;
      this.spillHistory = true;
      this.spillHistoryDetails = this.coastwatch.summary.spillData.map(
        (item) => {
          return {
            date: moment(item.date).format("Do MMM"),
            result: item.hasSpill ? "Yes" : "No",
            hasSpill: item.hasSpill,
          };
        }
      );
    },
    getLocationDetailsFinally() {
      this.loading = false;
    },
    getPriorityTitle(level) {
      if (level === "High") {
        return this.layer.highPriorityTitle;
      }
      if (level === "Mid") {
        return this.layer.midPriorityTitle;
      }
      if (level === "Low") {
        return this.layer.lowPriorityTitle;
      }
    },
    formatDate(date) {
      return moment(date).format("MMM Do YYYY");
    },
    closeButtonClickHandler() {
      this.$emit("modalClose");
    },
    onFocusoutClose(e) {
      if (e.shiftKey === false) {
        e.preventDefault();
        this.$refs.heading.focus();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/layered-map/MapModal.vue